<template>
   <section class="h-screen flex">
    <div class="w-1/2 flex flex-col justify-center px-16 bg-white">
      <!-- Logo -->
       <div class="3/5 mx-auto">
           <a href="/" class="mb-6">
             <img src="@/assets/images/logo.png" alt="MyUniversityOptions" class="w-64 mb-6">
           </a>
           <!-- Welcome Back Message -->
           <h2 class="text-2xl font-bold">Welcome back!</h2>
           <div class="border-b-2 border-purple w-32 mb-6"></div>
           <p class="text-gray-600 mb-6">Email to get unlimited access to data & information</p>
     
           <!-- Form -->
           <form class="space-y-4">
             <div>
               <label for="email" class="block text-gray-600 mb-1 font-bold">Email</label>
               <input type="email" id="email" class="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600" placeholder="Enter your email address">
             </div>
     
             <div>
               <label for="password" class="block text-gray-600 mb-1 font-bold">Password</label>
               <input type="password" id="password" class="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600" placeholder="Enter password">
             </div>
     
             <div class="flex items-center justify-between">
               <label class="flex items-center text-gray-600">
                 <input type="checkbox" class="mr-2">
                 Remember me
               </label>
               <a href="#" class="text-purple hover:underline font-bold">Forgot Your Password?</a>
             </div>
     
             <!-- Log In Button -->
             <button type="submit" class="w-full bg-purple text-white py-3 rounded-lg hover:bg-purple-800 transition">Log In</button>
           </form>
           <!-- OR Section -->
           <div class="text-center my-3">OR</div>
           <div class="space-y-4">
             <button class="w-full py-3 border border-gray-300 rounded-lg flex items-center justify-center hover:bg-gray-100 transition">
               <img src="/path/to/google-logo.png" alt="Google" class="w-5 h-5 mr-2">
               Sign up with Google
             </button>
             <button class="w-full py-3 border border-gray-300 rounded-lg flex items-center justify-center hover:bg-gray-100 transition">
               <img src="/path/to/email-logo.png" alt="Email" class="w-5 h-5 mr-2">
               Sign up with Email
             </button>
           </div>

       </div>
    </div>

    <!-- Right Section (Image) -->
    <div class="w-1/2" style="border-left:6px solid #7B0478;">
      <img src="@/assets/images/login.png" alt="Students walking" class="w-full h-full object-cover">
    </div>
  </section>
  </template>
  
  <script>
  
  export default {
    name: 'Login',
  }
  </script>
  